"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Team = void 0;
var create_entity_1 = require("../../utils/create-entity");
var components_1 = require("../../components");
var entity_select_transform_1 = require("../../utils/entity-select-transform");
var team_image_1 = require("../../components/entities/team-image");
var team_details_banner_1 = require("../../components/entities/team-details-banner");
var graphql_1 = require("../../utils/graphql");
exports.Team = {
  name: 'Team',
  slug: 'working-group',
  groupName: 'Participate',
  label: 'Working Group',
  components: {
    card: components_1.TeamCard,
    details: components_1.TeamDetailsLayout,
    image: team_image_1.TeamImage,
    banner: team_details_banner_1.TeamDetailsBanner
  },
  useSites: true,
  usePublishStatus: true,
  useConversation: true,
  useFollowers: true,
  usePermissions: true,
  includeInSearch: true,
  useModerators: true,
  useConnections: true,
  canEmbed: true,
  useSlices: true,
  select: {
    transform: function (entity, context) {
      return __assign(__assign({}, (0, entity_select_transform_1.entitySelectTransform)(entity, context)), {
        description: entity.summary && entity.summary.text
      });
    },
    queryFields: "\n      summary { id text }\n    "
  },
  autoRoutes: ['create', 'update', 'list', 'details'],
  list: {
    hasSearch: true,
    hasFilters: true,
    pad: true,
    banner: {
      title: 'Working Groups'
    },
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      description { id text(truncate: { words: 50 }) html }\n      summary { id text html }\n      workstreams { id }\n      typeLabel\n      type { id name slug }\n      status { id name slug }\n      organisationMembers { \n        id\n        organisation { id name slug url logo { id url thumbnails { id full { id url width height } } } }\n      }\n      members {\n        id\n        person {\n          id slug name\n          photo { id url thumbnails { id full { id url width height } } }\n          position\n          location { id name slug }\n        }\n      }\n    "], ["\n      description { id text(truncate: { words: 50 }) html }\n      summary { id text html }\n      workstreams { id }\n      typeLabel\n      type { id name slug }\n      status { id name slug }\n      organisationMembers { \n        id\n        organisation { id name slug url logo { id url thumbnails { id full { id url width height } } } }\n      }\n      members {\n        id\n        person {\n          id slug name\n          photo { id url thumbnails { id full { id url width height } } }\n          position\n          location { id name slug }\n        }\n      }\n    "])))
  },
  banner: {
    showDescription: true,
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      description { id text }\n      members {\n        id\n        role { id name slug }\n        person { id slug name position\n          bio { id plainTruncated: plain(truncate: { words: 60 }) }\n          organisation { id name slug\n            challenge { id name slug }\n          }\n          photo {\n            id url thumbnails { id full { id url width height } }\n          }\n          location { id name slug }\n        }\n      }\n    "], ["\n      description { id text }\n      members {\n        id\n        role { id name slug }\n        person { id slug name position\n          bio { id plainTruncated: plain(truncate: { words: 60 }) }\n          organisation { id name slug\n            challenge { id name slug }\n          }\n          photo {\n            id url thumbnails { id full { id url width height } }\n          }\n          location { id name slug }\n        }\n      }\n    "])))
  },
  export: {
    queryFields: (0, graphql_1.graphql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      agenda { id text }\n      description { id text }\n      organisationMembers { name role { name } organisation { name } }\n      files { name file { url } }\n      workstreams {\n        name \n        due \n        type { name }\n        status { name } \n        team { \n          name \n          description { text } \n        } \n        description { text } \n        tasks { \n          name \n          completed \n          due \n          description { text } \n        } \n        links { \n          name \n          url \n          types { name } \n          type { name } \n          image { url } \n        } \n        files { name file { url } } \n        documents { \n          name \n          type { name }\n        }\n      }\n      challenges { name }\n      keyIssues { name }\n      trends { name }\n      topics { name }\n      subTopics { name }\n\n      members {\n        role { name }\n        person { name }\n      }\n    "], ["\n      agenda { id text }\n      description { id text }\n      organisationMembers { name role { name } organisation { name } }\n      files { name file { url } }\n      workstreams {\n        name \n        due \n        type { name }\n        status { name } \n        team { \n          name \n          description { text } \n        } \n        description { text } \n        tasks { \n          name \n          completed \n          due \n          description { text } \n        } \n        links { \n          name \n          url \n          types { name } \n          type { name } \n          image { url } \n        } \n        files { name file { url } } \n        documents { \n          name \n          type { name }\n        }\n      }\n      challenges { name }\n      keyIssues { name }\n      trends { name }\n      topics { name }\n      subTopics { name }\n\n      members {\n        role { name }\n        person { name }\n      }\n    "])))
  },
  details: {
    label: 'Overview',
    queryFields: (0, graphql_1.graphql)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      agenda { id text }\n      description { id text }\n      organisationMembers { ...EntityValueFields role { ...EntityValueFields } organisation { ...EntityValueFields } }\n      files { ...FileAssetValueFields }\n      workstreams {\n        id name slug due type { id name slug } status { id name slug } team { id name slug description { id text } } description { id text html } tasks { id name slug completed due description { id text html } } links { id name slug url types { id name slug } type { id name slug } image { id url } } files { ...FileAssetValueFields } documents { id name slug type { id name slug } }\n      }\n\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n      videos { ...EntityValueFields url }\n\n      members {\n        ...EntityValueFields\n        role { ...EntityValueFields }\n        person { ...EntityValueFields }\n      }\n    "], ["\n      agenda { id text }\n      description { id text }\n      organisationMembers { ...EntityValueFields role { ...EntityValueFields } organisation { ...EntityValueFields } }\n      files { ...FileAssetValueFields }\n      workstreams {\n        id name slug due type { id name slug } status { id name slug } team { id name slug description { id text } } description { id text html } tasks { id name slug completed due description { id text html } } links { id name slug url types { id name slug } type { id name slug } image { id url } } files { ...FileAssetValueFields } documents { id name slug type { id name slug } }\n      }\n\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n      videos { ...EntityValueFields url }\n\n      members {\n        ...EntityValueFields\n        role { ...EntityValueFields }\n        person { ...EntityValueFields }\n      }\n    "])))
  },
  filters: {
    fields: {
      types: {
        entityTypeName: 'TeamType'
      },
      status: {
        entityTypeName: 'ProjectStatus'
      },
      challenges: {
        entityTypeName: 'Challenge'
      },
      keyIssues: {
        entityTypeName: 'KeyIssue'
      },
      economies: {
        entityTypeName: 'Economy'
      },
      locations: {
        entityTypeName: 'Location'
      }
    }
  },
  form: {
    modal: {
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'expertise'
    }, {
      name: 'roles'
    }, {
      name: 'taxonomies',
      label: process.env.TAXONOMIES_LABEL || 'Challenges & Goals'
    }, {
      name: 'activities'
    }, {
      name: 'places'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      description: {
        type: 'description'
      },
      agenda: {
        recommended: true,
        height: '200px',
        type: 'longText',
        description: 'Describe how this {{TEAM}} will address the {{CHALLENGES}} and {{KEY_ISSUES}} you identify below',
        fieldSet: 'overview'
      },
      banner: {
        type: 'banner',
        fieldSet: 'overview'
      },
      files: {
        type: 'linkedMultiple',
        entityTypeName: 'FileAsset'
      },
      videos: {
        type: 'linkedMultiple',
        entityTypeName: 'Video'
      },
      types: {
        type: 'linkedMultiple',
        label: 'Types',
        entityTypeName: 'TeamType',
        description: 'What type of {{TEAM}} is this?'
      },
      status: {
        type: 'linked',
        entityTypeName: 'ProjectStatus'
      },
      summary: {
        type: 'summary'
      },
      parent: {
        type: 'parent'
      },
      events: {
        type: 'linkedMultiple',
        entityTypeName: 'Event',
        fieldSet: 'overview'
      },
      pages: {
        type: 'linkedMultiple',
        entityTypeName: 'Page',
        fieldSet: 'overview'
      },
      locations: {
        type: 'linked',
        entityTypeName: 'Location',
        fieldSet: 'places'
      },
      economies: {
        type: 'linked',
        entityTypeName: 'Economy',
        fieldSet: 'places'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      },
      members: {
        type: 'linkedTable',
        label: "{{PEOPLE}}",
        entityTypeName: 'TeamRole',
        fieldSet: 'roles',
        description: 'Who are the people in this {{TEAM}}, and what are their {{ROLES}}?'
      },
      organisationMembers: {
        type: 'linkedTable',
        label: "{{ORGANISATIONS}}",
        fieldSet: 'roles',
        entityTypeName: 'OrganisationTeamRole',
        description: 'Do any {{ORGANISATIONS}} have roles in this {{TEAM}}?'
      },
      workstreams: {
        type: 'linkedTable',
        fieldSet: 'activities',
        entityTypeName: 'Workstream'
      }
    })
  }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;